export default __webpack_public_path__ + "assets/images/icon-call.9276540bf97638b8677272edca7c4724.svg";